import { onError } from '@apollo/client/link/error'

function createErrorLink() {
  return onError(
    ({ response, graphQLErrors, networkError, operation, forward }) => {
      if (networkError)
        // eslint-disable-next-line no-console
        console.error(
          `[Network error]: ${networkError} ${JSON.stringify({
            response,
            name: operation.operationName,
            variables: operation.variables,
            graphQLErrors,
          })}`,
        )

      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, path, ...rest }) => {
          if (message === 'PersistedQueryNotFound') return

          // eslint-disable-next-line no-console
          console.log(
            `[GraphQL error]: Operation: ${
              operation?.operationName
            } Message: ${message}, Path: ${path} Info: ${JSON.stringify(rest)}`,
          )
        })

        forward(operation)
      }

      if (operation.operationName === 'Me' && response) {
        response.errors = undefined
      }
    },
  )
}

export default createErrorLink
